import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import {
	AllTRAction,
	BookingRequestInfo,
	BuyerInfo,
	CertificateDetail,
	ITRAction,
	PSDocument,
	PSRole,
	PvtSellRequest,
	PvtSellResponse,
	SellRequestInfo
} from "../../../apis/privatesell/enitites";
import { Redirect } from "react-router";
import PropertyPhotos from "../Component/PropertyPhoto";
import { normalizeRemoteDocToPSDocument } from "../../../apis/privatesell/services";
import SellerDescription from "../Component/SellerDescription";
import PSPropertyDetail from "../Component/View/ViewPropertyDetail";
import BuyerDetail from "../Component/View/BuyerDetail";
import OwnerDetail from "../Component/View/OwnerDetail";
import ViewBankDetails from "../Component/View/ViewBankDetails";
import ViewBookingDetails from "../Component/View/ViewBookingDetails";
import ViewTerms from "../Component/View/ViewTerms";
import ReceiptDetails from "../Component/View/ReceiptDetails";
import RejectionComments from "../Component/View/RejectionComments";
import { DateUtil, LocaleUtil } from "@eres/core";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import AlertPopUp from "../Component/AlertPopUp";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { privateSellApi } from "../../../apis/privatesell";
import RejectRequest from "../BuyerFlow/RejectRequest";
import { dispatch, navigate } from "@my-dld/utils/StoreUtils";
import PrivateSellHeader from "../Component/PrivateSellHeader";
import { openDocument } from "@my-dld/utils/Utils";
import Switch from "@my-dld/components/Switch";
import { ImperialSystem, MetricSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import Actions from "@my-dld/actions";
import { getAppServices } from "@10x/coreapp";

interface State {
	role: PSRole;
	result: PvtSellResponse;
	unit: UnitSystem;
}

export default class BookingRequestDetails extends Component<RoutedViewProps, State> {
	property: AssetCard | undefined;
	request: PvtSellRequest | undefined;
	sellRequestInfo: SellRequestInfo | undefined;
	documents: PSDocument[] | undefined;
	bookingRequestInfo: BookingRequestInfo | undefined;
	certificate: CertificateDetail | undefined;

	constructor( props: RoutedViewProps ) {
		super( props );
		const state = props.location.state;
		this.state = {
			role: state ? state.role : undefined,
			result: state ? state.result : undefined,
			unit: getAppServices().storeService.getStore().getState().User.unit,
		};
		const request: PvtSellRequest = state && state.result && state.result.request ? state.result.request : undefined;
		this.request = request;
		this.certificate = state && state.result && state.result.certificate ? state.result.certificate : undefined;
		if ( request ) {
			this.property = ( request.propertyInfo &&
				request.propertyInfo.propertyObject ) ? JSON.parse( request.propertyInfo.propertyObject ) : undefined;
			this.sellRequestInfo = request.sellRequestInfo;
			this.documents = this.sellRequestInfo && this.sellRequestInfo.documents ? normalizeRemoteDocToPSDocument( this.sellRequestInfo.documents ) : undefined;
			this.bookingRequestInfo = request.bookingRequestInfo;
		}
	}

	render() {
		const { role, result, unit } = this.state;
		if ( !result ) {
			return <Redirect to={ "/" }/>;
		} else if ( !result && role === PSRole.SELLER ) {
			return <Redirect to={ "/mydld/my_requests/privateSell" }/>;
		} else {
			const { request } = result;
			// const roleHeading = role === PSRole.SELLER ? Strings.sell_property : Strings.gl_buy_property;
			// let heading = (result && request.bookingRequestInfo) ? Strings.booking_ref_number + " : " + request.bookingRequestInfo.referenceNumber : "";
			// const procedure = (request) ? getProcedureNumber(request.bookingRequestInfo) : undefined;
			// const headerProcedure = (procedure) ? " & " + Strings.procedure_number + " : " + procedure : "";
			return <PrivateSellHeader
				role={ role } request={ request } titleExtra={ <Switch
				id={ "result-unit" }
				onLabel={ Strings.sq_mt }
				offLabel={ Strings.sq_ft }
				value={ unit.Id === MetricSystem.Id }
				onChange={ ( isSqm ) => {
					const update = { unit: ImperialSystem };
					if ( isSqm ) update.unit = MetricSystem;
					this.setState( update, () => {
						dispatch( Actions.UNIT_CHANGED, unit );
					} );
				} }
			/> }>
				<PropertyPhotos documents={ this.documents } readonly={ true }/>
				<SellerDescription readonly={ true } description={ this.sellRequestInfo?.description }/>
				<PSPropertyDetail property={ this.property } unit={ unit }/>
				{
					role === PSRole.SELLER && this.bookingRequestInfo &&
					<BuyerDetail buyerInfo={ this.bookingRequestInfo.buyerInfo }/>
				}
				{
					role === PSRole.BUYER && this.sellRequestInfo &&
					<OwnerDetail sellerDetails={ this.sellRequestInfo.sellerDetails }/>
				}
				{
					role === PSRole.SELLER && this.sellRequestInfo && this.sellRequestInfo.bankAccount &&
					<ViewBankDetails bankAccount={ this.sellRequestInfo.bankAccount }/>
				}
				{
					this.sellRequestInfo && <ViewBookingDetails sellRequest={ this.sellRequestInfo }/>
				}
				{
					this.request && this.request.termsAndConditions &&
					<ViewTerms terms={ this.request.termsAndConditions }/>
				}
				{
					this.state.result && this.state.result.receipts && this.state.result.receipts.length > 0 &&
					<ReceiptDetails receipts={ this.state.result.receipts }/>
				}
				{
					this.bookingRequestInfo && this.bookingRequestInfo.bookingRequest && this.bookingRequestInfo.bookingRequest.commentList
					&& this.bookingRequestInfo.bookingRequest.commentList.length > 0 &&
					<RejectionComments comments={ this.bookingRequestInfo.bookingRequest.commentList }/>
				}
				<TRActions
					isSeller={ role === PSRole.SELLER } actions={ this.state.result.actions }
					onAction={ this.onTRAction }/>
				<AlertPopUp message={ Strings.cancel_confirm } OnDismiss={ this.onCancelRequest }/>
				{
					this.request && <RejectRequest transaction={ this.request } onReject={ this.onReject }/>
				}
			</PrivateSellHeader>;
		}
	}

	onReject = () => {
		// NavigationService.push(this.props.navigation, "BookingRequestReject", {transaction: this.state.transaction});
		JQModal( "message_action" ).hide( this.props.history.goBack );
	};

	onAccept = () => {
		const { request } = this;
		let buyerInfo: BuyerInfo | undefined = this.bookingRequestInfo?.buyerInfo;
		if ( buyerInfo ) {
			const eid = buyerInfo.emiratesId;
			const dob = DateUtil.formatDate( buyerInfo?.birthDate?.asDate()!, "YYYY-MM-DD", "en" );

			if ( ( eid !== undefined && eid !== null ) && eid.length === 15 ) {
				showLoading();
				const apiHandler = ( response: any ) => {
					hideLoading();
					let result = response;
					let buyer: BuyerInfo = buyerInfo!;
					if ( result && result.emiratesId ) {
						buyer = {
							...buyerInfo,
							...normalizeBuyer( result ),
						};
					}
					navigate( `/accept/${ this.bookingRequestInfo?.referenceNumber }`,
						undefined, {
							request: request,
							result: this.state.result,
							buyerInfo: buyer,
						} );
				};
				const exHandler = ( ex: any ) => {
					hideLoading();
				};
				privateSellApi.validatePersonByEmiratesId( eid, dob! ).then( apiHandler ).catch( exHandler );
			} else {
				navigate( `/accept/${ this.bookingRequestInfo?.referenceNumber }`,
					undefined, {
						request: request,
						result: this.state.result,
						buyerInfo: buyerInfo,
					} );
			}
		}
	};

	onPayment = () => {
		const canBook = this.state.result.actions.indexOf( 5 ) !== -1;
		navigate( `/payment/${ this.bookingRequestInfo?.referenceNumber }`,
			undefined, {
				receipts: this.state.result.receipts,
				canBook: canBook,
				result: this.state.result,
			} );
	};

	onCancelRequest = ( val: string ) => {
		if ( val === "yes" && this.request ) {
			const apiHandler = ( response: any ) => {
				hideLoading();
				showMessage( Strings.req_cancelled_sucess );
				this.props.history.goBack();
			};

			const exHandler = ( ex: any ) => {
				hideLoading();
				showMessage( ex.toString() );
			};
			showLoading();
			privateSellApi.cancelRequest( this.request.id.toString() ).then( apiHandler ).catch( exHandler );
		}
	};
	onTRAction = ( actionId: number ) => {
		const { property, request } = this;
		const tabuPropertyID = property?.propertyId;
		if ( actionId === 3 ) {
			// reject
			JQModal( "reject_comment_popup" ).show();
		} else if ( actionId === 2 ) {
			// accept
			this.onAccept();
		} else if ( actionId === 4 || actionId === 5 ) {
			// pay or book
			this.onPayment();
		} else if ( actionId === 8 ) {
			// download receipt handled in receipt sections
		} else if ( actionId === 10 ) {
			// download cert
			if ( this.certificate && this.certificate.filtPath ) {
				let cert = this.certificate;
				const statementUrl = cert.filtPath.replace( /\\/g, "/" );
				openDocument( statementUrl, Strings.title_deed );
			}
		} else if ( actionId === 9 ) {
			// cancell request
			JQModal( "alert-confirm" ).show();
		} else if ( actionId === 1 ) {
			// review
			navigate( `/mydld/privateSell/${ tabuPropertyID }`, undefined, {
				property: property,
				request: request,
			} );
		}
	};
}


function TRActions( props: { isSeller: boolean, actions: number[], onAction: ( actionId: number ) => void } ) {
	let { isSeller, actions, onAction } = props;
	actions = actions.slice();
	if ( actions.indexOf( 4 ) !== -1 && actions.indexOf( 5 ) !== -1 ) {
		actions.splice( actions.indexOf( 5 ), 1 );
	}
	if ( actions.indexOf( 8 ) !== -1 ) {
		actions.splice( actions.indexOf( 8 ), 1 );
	}
	let acts = AllTRAction.filter( trAction => {
		return trAction.user === "both" || ( isSeller && trAction.user === "seller" ) || ( !isSeller && trAction.user === "buyer" );
	} );
	acts = acts.filter( trAction => {
		return actions && actions.indexOf( trAction.id ) !== -1;
	} );
	let groupedActions: ITRAction[][] = acts.reduce( ( result: ITRAction[][], value, index, array ) => {
		let l = result.length;
		if ( l > 0 ) {
			let x = result[ l - 1 ];
			if ( x.length === 2 ) {
				result.push( array.slice( index, index + 1 ) );
			} else {
				let f = x[ 0 ];
				let c = array[ index ];
				if ( f.positive === c.positive ) {
					result.push( array.slice( index, index + 1 ) );
				} else
					x.push( c );
			}
		} else {
			result.push( array.slice( index, index + 1 ) );
		}
		return result;
	}, [] );
	let p: any[] = [];
	{
		groupedActions.map( ( ga: ITRAction[], ix ) => {
			{
				ga.map( ( action, index ) => {
					p.push( <button
						key={ "action_" + action.id } className="btn btn_1 btn_style1" type="button"
						data-item={ action.id } onClick={ () => {
						onAction( action.id );
					} }>
						{ LocaleUtil.getLocalValue( action.label ) }
					</button> );
				} );
			}
		} );
	}
	return <div className={ "sell-property-booking-action" }>{ p }</div>;
}

function normalizeBuyer( result: any ): BuyerInfo {
	let buyer: BuyerInfo = {
		...result,
		participantId: Number( result.participantId ),
		passportNumber: result.passport,
		emiratesIdExpiry: result.emiratesIDExpixy,
	};
	if ( result.emiratesId ) {
		if ( result.nationalityId ) {
			buyer.nationality = result.nationalityId;
		}
	}
	return buyer;
}
